module.exports = __webpack_public_path__ + "img/back.ca596571.svg";